export default __webpack_public_path__ + "static/media/PyragonWebICon.5c3f7eca.png";